export default __webpack_public_path__ + "tennis-live.png";